import { useState, useEffect, useCallback } from 'react';
import { ListTodo, Check, Clock, Play, X } from 'lucide-react';
import { SeverityBadge } from './SEOOSShared';
import { Button } from '@/components/ui/button';

const API = '';
const STATUS_TR = { open: 'Acik', in_progress: 'Devam Ediyor', completed: 'Tamamlandi', dismissed: 'Kapatildi' };

export default function SEOOSTasks() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const token = localStorage.getItem('admin_token');
  const headers = { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };

  const load = useCallback(() => {
    setLoading(true);
    fetch(`${API}/api/seoos/tasks`, { headers }).then(r => r.json()).then(d => { setData(d); setLoading(false); }).catch(() => setLoading(false));
  }, []);
  useEffect(() => { load(); }, [load]);

  const updateStatus = async (taskId, status) => {
    await fetch(`${API}/api/seoos/tasks/${taskId}/status?status=${status}`, { method: 'POST', headers });
    load();
  };

  if (loading || !data) return <div className="text-center py-16 text-slate-500">Yukleniyor...</div>;

  const { tasks, total, open } = data;
  const filtered = filter === 'all' ? tasks : tasks.filter(t => t.status === filter);

  return (
    <div className="space-y-6" data-testid="seoos-tasks">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-black text-white" style={{ fontFamily: 'var(--font-heading)' }}>
          <ListTodo className="w-5 h-5 inline mr-2 text-purple-400" />Muhendislik Gorevleri
        </h2>
        <span className="text-sm text-slate-500">{open} acik / {total} toplam</span>
      </div>

      <div className="flex gap-2">
        {[{key: 'all', label: 'Tumu'}, {key: 'open', label: 'Acik'}, {key: 'in_progress', label: 'Devam Ediyor'}, {key: 'completed', label: 'Tamamlandi'}, {key: 'dismissed', label: 'Kapatildi'}].map(f => (
          <button key={f.key} onClick={() => setFilter(f.key)}
            className={`px-3 py-1.5 rounded-lg text-xs font-bold uppercase ${filter === f.key ? 'bg-purple-500/20 text-purple-300 border border-purple-500/30' : 'bg-slate-800/40 text-slate-500 border border-transparent'}`}>
            {f.label} ({f.key === 'all' ? total : tasks.filter(t => t.status === f.key).length})
          </button>
        ))}
      </div>

      <div className="space-y-3">
        {filtered.map(task => (
          <div key={task.id} className="bg-slate-900/40 border border-slate-800/50 rounded-xl p-5">
            <div className="flex items-center gap-3 mb-3">
              <span className={`text-xs font-bold px-2.5 py-1 rounded-full border ${
                task.priority === 'P0' ? 'text-red-400 bg-red-500/10 border-red-500/30'
                : task.priority === 'P1' ? 'text-orange-400 bg-orange-500/10 border-orange-500/30'
                : 'text-amber-400 bg-amber-500/10 border-amber-500/30'
              }`}>{task.priority_label || task.priority}</span>
              <h3 className="text-sm font-bold text-white flex-1">{task.title?.replace(/\[.*?\]\s*/, '')}</h3>
              <span className={`text-[10px] px-2 py-0.5 rounded-full border ${
                task.status === 'open' ? 'text-amber-400 bg-amber-500/10 border-amber-500/20'
                : task.status === 'completed' ? 'text-emerald-400 bg-emerald-500/10 border-emerald-500/20'
                : task.status === 'in_progress' ? 'text-blue-400 bg-blue-500/10 border-blue-500/20'
                : 'text-slate-500 bg-slate-800 border-slate-700'
              }`}>{STATUS_TR[task.status] || task.status}</span>
            </div>

            <p className="text-xs text-slate-400 mb-3">{task.description?.slice(0, 200)}</p>

            <div className="flex items-center gap-4 text-[10px] text-slate-500 mb-3">
              <span>{task.affected_pages} sayfa etkileniyor</span>
              <span className="text-emerald-400">{task.estimated_impact}</span>
              <span>{task.category}</span>
            </div>

            {task.steps?.length > 0 && (
              <div className="bg-slate-800/30 rounded-lg p-3 mb-3">
                <p className="text-[10px] text-slate-500 uppercase font-bold mb-1">Adimlar:</p>
                {task.steps.map((step, i) => (
                  <p key={i} className="text-xs text-slate-400 ml-2">{step}</p>
                ))}
              </div>
            )}

            {task.files_to_modify?.length > 0 && (
              <div className="flex flex-wrap gap-1 mb-3">
                {task.files_to_modify.map((f, i) => (
                  <code key={i} className="text-[10px] bg-purple-500/10 text-purple-300 px-2 py-0.5 rounded border border-purple-500/20">{f}</code>
                ))}
              </div>
            )}

            <div className="flex gap-2 pt-2 border-t border-slate-800/30">
              {task.status === 'open' && (
                <>
                  <Button size="sm" onClick={() => updateStatus(task.id, 'in_progress')} className="bg-blue-600 hover:bg-blue-500 text-xs h-7"><Play className="w-3 h-3 mr-1" />Baslat</Button>
                  <Button size="sm" variant="ghost" onClick={() => updateStatus(task.id, 'dismissed')} className="text-slate-500 text-xs h-7"><X className="w-3 h-3 mr-1" />Kapat</Button>
                </>
              )}
              {task.status === 'in_progress' && (
                <Button size="sm" onClick={() => updateStatus(task.id, 'completed')} className="bg-emerald-600 hover:bg-emerald-500 text-xs h-7"><Check className="w-3 h-3 mr-1" />Tamamla</Button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
